
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LocaleItemProps } from ".";
import { loading, update } from "store/locale";
import { AppMessage } from "components";

interface ApiLocaleUpdateInputProps extends LocaleItemProps {
}

type ApiLocaleUpdateOutputProps = OutputBaseProps<{ item: LocaleItemProps; }, ApiLocaleUpdateInputProps>

export const apiLocaleUpdate = async (data: ApiLocaleUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiLocaleUpdateOutputProps>("/api/locale/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};